import {ActiveFilters} from "../types/filterTypes";
import {CollectionClip} from "@/types/collectionTypes";

export enum CHAT_MESSAGE_TYPE {
    USER = 'user',
    AGENT = 'agent',
}

export interface Message {
    id: string;
    type: CHAT_MESSAGE_TYPE;
    content: string;
    timestamp: Date;
}

export interface StartResponse{
    conversation_id: string
    message: string
}

export enum UI_ACTION_TYPE {
    CREATE_CONTENT = 'CREATE_CONTENT',
    NAVIGATION_PAGE = 'NAVIGATION_PAGE',
    FILTER = 'GET_CONTENT',
    POST_MATERIALIZATION = 'POST_MATERIALIZATION',
}

export interface UICreateContentActionParams{
    content_id: string,
    clip_name: string,
    content_type: string,
    filter_by_str: ActiveFilters,
    media: CollectionClip[] | null | undefined
}

export interface UINavigationPageActionParams{
    url: string,
    event_id?: string
    collection_type?: string,
    content_type?: string,
}

export interface UIFilterAction{
    resource_type: string,
    filter_by_str: ActiveFilters,
}

export type UIAction =
    | { type: UI_ACTION_TYPE.CREATE_CONTENT; params: UICreateContentActionParams }
    | { type: UI_ACTION_TYPE.NAVIGATION_PAGE; params: UINavigationPageActionParams }
    | { type: UI_ACTION_TYPE.FILTER; params: UIFilterAction }
    | { type: UI_ACTION_TYPE.POST_MATERIALIZATION; params: {} }

export interface TourStepMessage {
    isCertain: boolean
    agenticDataValue: string
    agenticDataType: string
}

export interface TourMessage {
    steps: string[]
    data: TourStepMessage[]
}


export interface MessageResponse{
    reply: string
    //actions: UIAction[]
    //choices: string[][]
    conversation_id: string
    //media?: CollectionClip[]
    tour: TourMessage
}

export interface MessageConversationalResponse{
    reply: string
    actions: UIAction[]
    choices: string[][]
    conversation_id: string
    media?: CollectionClip[]
}

export interface CloseResponse{
    conversation_id: string,
    message: string
}